import React from 'react';
import checkbanque from '../../../../../../../assets/images/svg/016-account-card.svg';
import {Card} from './card';
import {PasService} from './pasService';
import {BankAccountType} from '../../../../../../../constants/models/servicePayloads/bankAccountType';

export const CompteCurrent = ({branch, isMain, globalPayload, setGlobalPayload, displayComments, disableModifications}) => {
    const cardTypes = [BankAccountType.CompteCurrent];

    return (
        <div className="grid grid-md-min grid-lg-tight grid-lg-4">
            {
                cardTypes.map((name, index) => {
                    return <Card key={index} cardType={name} icon={checkbanque} branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload}  displayComments={displayComments} disableModifications={disableModifications}/>
                })
            }
            {/* <PasService icon={checkbanque} cardType={BankAccountType.PasCurrent}/> */}
        </div>
    );
}